import React from 'react';
import { IconButton } from '@airbus/components-react';
import { Close } from '@airbus/icons/react';

import classes from './CompanyTitle.module.css';

type Props = {
    handleClose: () => void;
};

const AircraftTitle = ({ handleClose }: Props) => {
    return (
        <div className={classes.container}>
            <div className={classes.left}>Aircraft</div>
            <div className={classes.right} onClick={handleClose}>
                <IconButton size="small" variant="ghost">
                    <Close onClick={handleClose} />
                </IconButton>
            </div>
        </div>
    );
};

export default AircraftTitle;
